// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';

// const StudentDetail = () => {
//   const { regid } = useParams();
//   const [student, setStudent] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchStudent = async () => {
//       try {
//         const res = await fetch(`/api/student/${regid}`);
//         const data = await res.json();
//         setStudent(data);
//         setLoading(false);
//       } catch (err) {
//         console.error("Failed to load student", err);
//       }
//     };

//     fetchStudent();
//   }, [regid]);

//   if (loading) return <p>Loading...</p>;
//   if (!student) return <p>Student not found.</p>;

//   return (
//     <div className="container mt-4">
//       <h2>Student Details</h2>
//       <p><strong>Name:</strong> {student.fName} {student.lName}</p>
//       <p><strong>Registration ID:</strong> {student.regid}</p>
//       <p><strong>Course:</strong> {student.courseName}</p>
//       <p><strong>Grade:</strong> {student.certificateGrade}</p>
//       <p><strong>Father's Name:</strong> {student.guardianName}</p>
//       {/* <p><strong>Software Covered:</strong> {student.softwareCovered}</p>
//       <p><strong>Duration:</strong> {student.duration}</p> */}
//     </div>
//   );
// };

// export default StudentDetail;
// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// const StudentDetail = () => {
//   // For demo purposes, using a mock regid - you'll use useParams() in your actual implementation
// const { regid } = useParams();
//   const [student, setStudent] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchStudent = async () => {
//       try {
//         const res = await fetch(`/api/student/${regid}`);
//         const data = await res.json();
//         setStudent(data);
//         setLoading(false);
//       } catch (err) {
//         console.error("Failed to load student", err);
//         setLoading(false);
//       }
//     };

//     fetchStudent();
//   }, [regid]);

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 d-flex align-items-center justify-content-center">
//         <div className="text-center">
//           <div className="spinner-border text-primary mb-3" role="status" style={{width: '3rem', height: '3rem'}}>
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <h5 className="text-muted">Verifying Certificate...</h5>
//         </div>
//       </div>
//     );
//   }

//   if (!student) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-100 d-flex align-items-center justify-content-center">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-md-6">
//               <div className="card border-0 shadow-lg">
//                 <div className="card-body text-center p-5">
//                   <div className="mb-4">
//                     <i className="fas fa-exclamation-triangle text-warning" style={{fontSize: '4rem'}}></i>
//                   </div>
//                   <h3 className="card-title text-danger mb-3">Certificate Not Found</h3>
//                   <p className="card-text text-muted mb-4">
//                     The certificate with the provided registration ID could not be verified. 
//                     Please check the registration ID and try again.
//                   </p>
//                   <button className="btn btn-outline-primary" onClick={() => window.history.back()}>
//                     Go Back
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
//       {/* Header Section */}
//       <div className="bg-white shadow-sm border-bottom">
//         <div className="container py-4">
//           <div className="row align-items-center">
//             <div className="col-md-8">
//               <div className="d-flex align-items-center">
//                 <div className="me-4">
//                   <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" 
//                        style={{width: '60px', height: '60px'}}>
//                     <i className="fas fa-graduation-cap text-white fs-3"></i>
//                   </div>
//                 </div>
//                 <div>
//                   <h2 className="mb-1 text-primary fw-bold">Excerpt IT Training Services</h2>
//                   <p className="text-muted mb-0">Certificate Verification Portal</p>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 text-md-end">
//               <div className="badge bg-success fs-6 px-3 py-2">
//                 <i className="fas fa-check-circle me-1"></i>
//                 Verified Certificate
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="container py-5">
//         <div className="row justify-content-center">
//           <div className="col-lg-10">
//             {/* Welcome Message */}
//             <div className="text-center mb-5">
//               <h1 className="display-5 fw-bold text-dark mb-3">
//                 Welcome to Certificate Verification
//               </h1>
//               <p className="lead text-muted">
//                 We are pleased to present the verified certificate details for the following graduate
//               </p>
//             </div>

//             {/* Certificate Card */}
//             <div className="card border-0 shadow-lg overflow-hidden">
//               <div className="card-header bg-gradient bg-primary text-white py-4">
//                 <div className="row align-items-center">
//                   <div className="col-md-8">
//                     <h3 className="card-title mb-1 fw-bold">
//                       <i className="fas fa-certificate me-2"></i>
//                       Certificate Details
//                     </h3>
//                     <p className="mb-0 opacity-75">Registration ID: {student.regid}</p>
//                   </div>
//                   <div className="col-md-4 text-md-end">
//                     <div className="bg-white bg-opacity-25 rounded-pill px-3 py-1 d-inline-block">
//                       <i className="fas fa-shield-check me-1"></i>
//                       Authenticated
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="card-body p-0">
//                 {/* Student Info Section */}
//                 <div className="p-4 p-md-5">
//                   <div className="row g-4">
//                     <div className="col-md-6">
//                       <div className="border-start border-primary border-4 ps-4">
//                         <h5 className="text-primary fw-semibold mb-2">Student Information</h5>
//                         <div className="mb-3">
//                           <label className="fw-bold text-dark mb-1">Full Name</label>
//                           <p className="fs-5 text-dark mb-0">{student.fName} {student.lName}</p>
//                         </div>
//                         <div className="mb-3">
//                           <label className="fw-bold text-dark mb-1">Guardian/Father's Name</label>
//                           <p className="text-muted mb-0">{student.guardianName}</p>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="col-md-6">
//                       <div className="border-start border-success border-4 ps-4">
//                         <h5 className="text-success fw-semibold mb-2">Course Information</h5>
//                         <div className="mb-3">
//                           <label className="fw-bold text-dark mb-1">Course Name</label>
//                           <p className="fs-5 text-dark mb-0">{student.courseName}</p>
//                         </div>
//                         <div className="mb-3">
//                           <label className="fw-bold text-dark mb-1">Certificate Grade</label>
//                           <span className="badge bg-warning text-dark fs-6 px-3 py-2">
//                             {student.certificateGrade}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Verification Footer */}
//                 <div className="bg-light border-top p-4">
//                   <div className="row align-items-center">
//                     <div className="col-md-8">
//                       <div className="d-flex align-items-center">
//                         <i className="fas fa-check-circle text-success me-3 fs-4"></i>
//                         <div>
//                           <h6 className="mb-1 fw-bold">Certificate Verified Successfully</h6>
//                           <p className="text-muted small mb-0">
//                             This certificate has been verified against our official records and is authentic.
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-md-4 text-md-end mt-3 mt-md-0">
//                       <p className="text-muted small mb-1">Verified on</p>
//                       <p className="fw-bold text-dark mb-0">
//                         {new Date().toLocaleDateString('en-US', { 
//                           year: 'numeric', 
//                           month: 'long', 
//                           day: 'numeric' 
//                         })}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Additional Information */}
//             <div className="row mt-4 g-4">
//               <div className="col-md-6">
//                 <div className="card border-0 shadow-sm h-100">
//                   <div className="card-body text-center p-4">
//                     <i className="fas fa-award text-primary mb-3" style={{fontSize: '2.5rem'}}></i>
//                     <h5 className="card-title">Quality Assured</h5>
//                     <p className="card-text text-muted">
//                       This certificate represents successful completion of our comprehensive training program.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="card border-0 shadow-sm h-100">
//                   <div className="card-body text-center p-4">
//                     <i className="fas fa-globe text-success mb-3" style={{fontSize: '2.5rem'}}></i>
//                     <h5 className="card-title">Industry Recognized</h5>
//                     <p className="card-text text-muted">
//                       Our certifications are recognized by leading companies in the IT industry.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Footer Message */}
//             <div className="text-center mt-5">
//               <p className="text-muted">
//                 For any queries regarding this certificate, please contact{' '}
//                 <strong>Excerpt IT Training Services</strong> through our official channels.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDetail;

// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';

// const StudentDetail = () => {
//   const { regid } = useParams();
//   const [student, setStudent] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // Helper function to capitalize names (first letter of each word)
//   const capitalizeName = (name) => {
//     if (!name) return '';
//     return name.split(' ')
//       .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(' ');
//   };

//   // Helper function to convert to camel case
//   const toCamelCase = (str) => {
//     if (!str) return '';
//     return str.split(' ')
//       .map((word, index) => {
//         if (index === 0) {
//           return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//         }
//         return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//       })
//       .join(' ');
//   };

//   useEffect(() => {
//     const fetchStudent = async () => {
//       try {
//         const res = await fetch(`/api/student/${regid}`);
//         const data = await res.json();
//         setStudent(data);
//         setLoading(false);
//       } catch (err) {
//         console.error("Failed to load student", err);
//         setLoading(false);
//       }
//     };

//     fetchStudent();
//   }, [regid]);

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{height: '60vh'}}>
//         <div className="text-center">
//           <div className="spinner-border text-primary mb-2" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="text-muted">Verifying Certificate...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!student) {
//     return (
//       <div className="container mt-5">
//         <div className="row justify-content-center">
//           <div className="col-md-6">
//             <div className="card border-danger">
//               <div className="card-body text-center p-4">
//                 <i className="fas fa-exclamation-triangle text-danger mb-3" style={{fontSize: '2rem'}}></i>
//                 <h4>Certificate Not Found</h4>
//                 <p className="text-muted">Invalid registration ID</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-light min-vh-100">
//       {/* Compact Header */}
//       <div className="bg-white shadow-sm py-3">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-md-8">
//               <div className="d-flex align-items-center">
//                 <div className="bg-primary rounded-circle me-3 d-flex align-items-center justify-content-center" 
//                      style={{width: '50px', height: '50px'}}>
//                   <i className="fas fa-graduation-cap text-white"></i>
//                 </div>
//                 <div>
//                   <h4 className="mb-0 text-primary fw-bold">Excerpt IT Training Services</h4>
//                   <small className="text-muted">Certificate Verification Portal</small>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 text-md-end">
//               <span className="badge bg-success px-3 py-2">
//                 <i className="fas fa-check-circle me-1"></i>Verified
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Certificate Card */}
//       <div className="container py-4">
//         <div className="row justify-content-center">
//           <div className="col-lg-8">
//             <div className="card shadow border-0">
//               <div className="card-header bg-primary text-white py-3">
//                 <div className="row align-items-center">
//                   <div className="col">
//                     <h5 className="mb-0 fw-bold">
//                       <i className="fas fa-certificate me-2"></i>Certificate Details
//                     </h5>
//                   </div>
//                   <div className="col-auto">
//                     <small>ID: {student.regid}</small>
//                   </div>
//                 </div>
//               </div>
              
//               <div className="card-body p-4">
//                 <div className="row g-4">
//                   {/* Student Info */}
//                   <div className="col-md-6">
//                     <h6 className="text-primary fw-semibold mb-3">
//                       <i className="fas fa-user me-2"></i>Student Information
//                     </h6>
//                     <div className="mb-3">
//                       <label className="fw-bold text-dark small">FULL NAME</label>
//                       <p className="h5 mb-1">{capitalizeName(student.fName)} {capitalizeName(student.lName)}</p>
//                     </div>
//                     <div>
//                       <label className="fw-bold text-dark small">FATHER'S NAME</label>
//                       <p className="mb-0">{toCamelCase(student.guardianName)}</p>
//                     </div>
//                   </div>

//                   {/* Course Info */}
//                   <div className="col-md-6">
//                     <h6 className="text-success fw-semibold mb-3">
//                       <i className="fas fa-book me-2"></i>Course Information
//                     </h6>
//                     <div className="mb-3">
//                       <label className="fw-bold text-dark small">COURSE NAME</label>
//                       <p className="h6 mb-1">{toCamelCase(student.courseName)}</p>
//                     </div>
//                     <div>
//                       <label className="fw-bold text-dark small">GRADE ACHIEVED</label>
//                       <div className="mt-1">
//                         <span className="badge bg-warning text-dark fs-6 px-3 py-2">
//                           {student.certificateGrade}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Uncomment if you want to show software covered and duration */}
//                 {/* 
//                 <hr className="my-4" />
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="fw-bold text-dark small">SOFTWARE COVERED</label>
//                     <p className="mb-0">{student.softwareCovered}</p>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="fw-bold text-dark small">DURATION</label>
//                     <p className="mb-0">{student.duration}</p>
//                   </div>
//                 </div>
//                 */}
//               </div>

//               {/* Verification Footer */}
//               <div className="card-footer bg-light py-3">
//                 <div className="row align-items-center">
//                   <div className="col">
//                     <div className="d-flex align-items-center">
//                       <i className="fas fa-shield-check text-success me-2"></i>
//                       {/* <div>
//                         <strong className="text-success">Certificate Verified</strong>
//                         <br />
//                         <small className="text-muted">
//                           Verified on {new Date().toLocaleDateString()}
//                         </small>
//                       </div> */}
//                     </div>
//                   </div>
//                   <div className="col-auto">
//                     <small className="text-muted">
//                       © Excerpt IT Training Services
//                     </small>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Contact Info */}
//             {/* <div className="text-center mt-3">
//               <small className="text-muted">
//                 For verification queries, contact <strong>Excerpt IT Training Services</strong>
//               </small>
//             </div> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDetail;
// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';

// const StudentDetail = () => {
//   const location = useLocation();
  
//   // Get regid from multiple sources:
//   // 1. From state (when navigated from within app)
//   // 2. From query parameters (when accessed via QR code)
//   // 3. From hash (if using hash-based approach)
  
//   // const getRegidFromSources = () => {
//   //   // From state
//   //   if (location.state?.regid) {
//   //     return location.state.regid;
//   //   }
    
//   //   // From query parameters
//   //   const urlParams = new URLSearchParams(location.search);
//   //   const queryRegid = urlParams.get('regid');
//   //   if (queryRegid) {
//   //     return queryRegid;
//   //   }
    
//   //   // From hash (if using option 2)
//   //   if (location.hash) {
//   //     return location.hash.substring(1); // Remove the # symbol
//   //   }
    
//   //   // If using base64 encoded regid
//   //   const encodedId = urlParams.get('id');
//   //   if (encodedId) {
//   //     try {
//   //       return atob(encodedId); // base64 decode
//   //     } catch (error) {
//   //       console.error('Error decoding regid:', error);
//   //     }
//   //   }
    
//   //   return null;
//   // };
//   // In your StudentDetail.js, update the getRegidFromSources function:

// const getRegidFromSources = () => {
//   console.log('=== STUDENT DETAIL (HASH METHOD) ===');
//   console.log('Full URL:', window.location.href);
//   console.log('Location hash:', location.hash);
  
//   // From state (when navigated from within app)
//   if (location.state?.regid) {
//     console.log('Found regid in state:', location.state.regid);
//     return location.state.regid;
//   }
  
//   // From hash (when accessed via QR code)
//   if (location.hash) {
//     const regidFromHash = location.hash.substring(1); // Remove the # symbol
//     console.log('Raw hash value:', regidFromHash);
//     console.log('Using regid from hash:', regidFromHash);
//     console.log('===============================');
//     return regidFromHash;
//   }
  
//   // Fallback: try query parameter (for backward compatibility)
//   const urlParams = new URLSearchParams(location.search);
//   const queryRegid = urlParams.get('regid');
//   if (queryRegid) {
//     console.log('Found regid in query param (fallback):', queryRegid);
//     console.log('===============================');
//     return queryRegid;
//   }
  
//   console.log('No regid found in any source');
//   console.log('===============================');
//   return null;
// };


// // Remove the base64 decoding part since we're not using it anymore
//   const regid = getRegidFromSources();
//   const [student, setStudent] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // Helper function to capitalize names (first letter of each word)
//   const capitalizeName = (name) => {
//     if (!name) return '';
//     return name.split(' ')
//       .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(' ');
//   };

//   // Helper function to convert to camel case
//   const toCamelCase = (str) => {
//     if (!str) return '';
//     return str.split(' ')
//       .map((word, index) => {
//         if (index === 0) {
//           return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//         }
//         return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//       })
//       .join(' ');
//   };

//   useEffect(() => {
//     // Check if regid exists
//     if (!regid) {
//       setLoading(false);
//       return;
//     }

//     const fetchStudent = async () => {
//       try {
//         const res = await fetch(`http://localhost:8080/api/student/${regid}`);
//         const data = await res.json();
//         console.log("std",data)
//         setStudent(data);
//         setLoading(false);
//       } catch (err) {
//         console.error("Failed to load student", err);
//         setLoading(false);
//       }
//     };

//     fetchStudent();
//   }, [regid]);

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{height: '60vh'}}>
//         <div className="text-center">
//           <div className="spinner-border text-primary mb-2" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="text-muted">Verifying Certificate...</p>
//         </div>
//       </div>
//     );
//   }

//   // Handle case where regid is not provided
//   if (!regid) {
//     return (
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-md-6">
//             <div className="card border-danger">
//               <div className="card-body text-center p-4">
//                 <i className="fas fa-exclamation-triangle text-danger mb-3" style={{fontSize: '2rem'}}></i>
//                 <h4>Access Error</h4>
//                 <p className="text-muted">Registration ID not provided</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!student) {
//     return (
//       <div className="container mt-5">
//         <div className="row justify-content-center">
//           <div className="col-md-6">
//             <div className="card border-danger">
//               <div className="card-body text-center p-4">
//                 <i className="fas fa-exclamation-triangle text-danger mb-3" style={{fontSize: '2rem'}}></i>
//                 <h4>Certificate Not Found</h4>
//                 <p className="text-muted">Invalid registration ID</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-light min-vh-100">
//       {/* Compact Header */}
//       <div className="bg-white shadow-sm py-3">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-md-8">
//               <div className="d-flex align-items-center">
//                 <div className="bg-primary rounded-circle me-3 d-flex align-items-center justify-content-center" 
//                      style={{width: '50px', height: '50px'}}>
//                   <i className="fas fa-graduation-cap text-white"></i>
//                 </div>
//                 <div>
//                   <h4 className="mb-0 text-primary fw-bold">Excerpt IT Training Services</h4>
//                   <small className="text-muted">Certificate Verification Portal</small>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-4 text-md-end">
//               <span className="badge bg-success px-3 py-2">
//                 <i className="fas fa-check-circle me-1"></i>Verified
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Certificate Card */}
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-lg-8">
//             <div className="card shadow border-0 w-100">
//               <div className="card-header bg-primary text-white py-3">
//                 <div className="row align-items-center">
//                   <div className="col">
//                     <h5 className="mb-0 fw-bold">
//                       <i className="fas fa-certificate me-2"></i>Certificate Details
//                     </h5>
//                   </div>
//                   <div className="col-auto">
//                     <small>ID: {student.regid}</small>
//                   </div>
//                 </div>
//               </div>
              
//               <div className="card-body p-4">
//                 <div className="row g-4">
//                   {/* Student Info */}
//                   <div className="col-md-6">
//                     <h6 className="text-primary fw-semibold mb-3">
//                       <i className="fas fa-user me-2"></i>Student Information
//                     </h6>
//                     <div className="mb-3">
//                       <label className="fw-bold text-dark small">FULL NAME</label>
//                       <p className="h5 mb-1">{capitalizeName(student.fName)} {capitalizeName(student.lName)}</p>
//                     </div>
//                     <div>
//                       <label className="fw-bold text-dark small">FATHER'S NAME</label>
//                       <p className="mb-0">{toCamelCase(student.guardianName)}</p>
//                     </div>
//                   </div>

//                   {/* Course Info */}
//                   <div className="col-md-6">
//                     <h6 className="text-success fw-semibold mb-3">
//                       <i className="fas fa-book me-2"></i>Course Information
//                     </h6>
//                     <div className="mb-3">
//                       <label className="fw-bold text-dark small">COURSE NAME</label>
//                       <p className="h6 mb-1">{toCamelCase(student.courseName)}</p>
//                     </div>
//                     <div>
//                       <label className="fw-bold text-dark small">GRADE ACHIEVED</label>
//                       <div className="mt-1">
//                         <span className="badge bg-warning text-dark fs-6 px-3 py-2">
//                           {student.certificateGrade}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Verification Footer */}
//               <div className="card-footer bg-light py-3">
//                 <div className="row align-items-center">
//                   <div className="col">
//                     <div className="d-flex align-items-center">
//                       <i className="fas fa-shield-check text-success me-2"></i>
//                     </div>
//                   </div>
//                   <div className="col-auto">
//                     <small className="text-muted">
//                       © Excerpt IT Training Services
//                     </small>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDetail;

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const StudentDetail = () => {
  const location = useLocation();
  
  const getRegidFromSources = () => {
    console.log('=== STUDENT DETAIL DEBUG START ===');
    console.log('Full URL:', window.location.href);
    console.log('Location pathname:', location.pathname);
    console.log('Location search:', location.search);
    console.log('Location hash:', location.hash);
    console.log('Location state:', location.state);
    
    // From state (when navigated from within app)
    if (location.state?.regid) {
      console.log('✅ Found regid in state:', location.state.regid);
      console.log('=== STUDENT DETAIL DEBUG END ===');
      return location.state.regid;
    }
    
    // From hash (when accessed via QR code with # method)
    if (location.hash) {
      const regidFromHash = location.hash.substring(1); // Remove the # symbol
      console.log('✅ Found regid in hash:', regidFromHash);
      console.log('Hash length:', regidFromHash.length);
      console.log('=== STUDENT DETAIL DEBUG END ===');
      return regidFromHash;
    }
    
    // From query parameters (fallback for ?regid= method)
    const urlParams = new URLSearchParams(location.search);
    console.log('All URL params:', Object.fromEntries(urlParams.entries()));
    const queryRegid = urlParams.get('regid');
    if (queryRegid) {
      console.log('✅ Found regid in query param:', queryRegid);
      console.log('=== STUDENT DETAIL DEBUG END ===');
      return queryRegid;
    }
    
    console.log('❌ No regid found in any source!');
    console.log('=== STUDENT DETAIL DEBUG END ===');
    return null;
  };

  const regid = getRegidFromSources();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);

  // Helper function to capitalize names (first letter of each word)
  const capitalizeName = (name) => {
    if (!name) return '';
    return name.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Helper function to convert to camel case
  const toCamelCase = (str) => {
    if (!str) return '';
    return str.split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  };

  useEffect(() => {
    console.log('=== USEEFFECT DEBUG ===');
    console.log('RegID received in useEffect:', regid);
    console.log('RegID type:', typeof regid);
    console.log('RegID length:', regid ? regid.length : 'null');
    
    // Check if regid exists
    if (!regid) {
      console.log('❌ No regid provided, stopping fetch');
      setLoading(false);
      return;
    }

    // const fetchStudent = async () => {
    //   try {
    //     const apiUrl = `http://localhost:8080/api/verification/${regid}`;
    //     console.log('=== API CALL DEBUG ===');
    //     console.log('🔍 Calling API URL:', apiUrl);
    //     console.log('🔍 RegID being sent:', regid);
        
    //     const res = await fetch(apiUrl);
        
    //     console.log('📡 API Response Status:', res.status);
    //     console.log('📡 API Response OK:', res.ok);
    //     console.log('📡 API Response Headers:', [...res.headers.entries()]);
        
    //     if (!res.ok) {
    //       const errorText = await res.text();
    //       console.error('❌ API Error Response:', errorText);
    //       setApiError(`API Error: ${res.status} - ${errorText}`);
    //       setLoading(false);
    //       return;
    //     }
        
    //     const data = await res.json();
    //     console.log('✅ API Response Data:', data);
    //     console.log('✅ Student Name:', data.fName, data.lName);
    //     console.log('✅ Student RegID:', data.regid);
    //     console.log('=== API CALL DEBUG END ===');
        
    //     setStudent(data);
    //     setLoading(false);
    //   } catch (err) {
    //     console.error('❌ Fetch Error:', err);
    //     console.error('❌ Error Type:', err.constructor.name);
    //     console.error('❌ Error Message:', err.message);
    //     setApiError(`Network Error: ${err.message}`);
    //     setLoading(false);
    //   }
    // };
// Frontend - StudentDetail.js
// Replace the fetchStudent function in useEffect

const fetchStudent = async () => {
  try {
    const apiUrl = `/api/verification`;
    
    console.log('=== API CALL DEBUG (POST METHOD) ===');
    console.log('🔍 Original RegID:', regid);
    console.log('🔍 API URL:', apiUrl);
    console.log('🔍 Request Method: POST');
    console.log('🔍 Request Body:', { regid });
    
    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        regid: regid
      })
    });
    
    console.log('📡 API Response Status:', res.status);
    console.log('📡 API Response OK:', res.ok);
    console.log('📡 API Response URL:', res.url);
    
    if (!res.ok) {
      const errorText = await res.text();
      console.error('❌ API Error Response:', errorText);
      setApiError(`API Error: ${res.status} - ${errorText}`);
      setLoading(false);
      return;
    }
    
    const data = await res.json();
    console.log('✅ API Response Data:', data);
    console.log('✅ Student Name:', data?.fName, data?.lName);
    console.log('✅ Student RegID:', data?.regid);
    console.log('=== API CALL DEBUG END ===');
    
    setStudent(data);
    setLoading(false);
  } catch (err) {
    console.error('❌ Fetch Error:', err);
    console.error('❌ Error Type:', err.constructor.name);
    console.error('❌ Error Message:', err.message);
    setApiError(`Network Error: ${err.message}`);
    setLoading(false);
  }
};


    fetchStudent();
  }, [regid]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{height: '60vh'}}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Verifying Certificate...</p>
          <small className="text-info">RegID: {regid}</small>
        </div>
      </div>
    );
  }

  // Handle case where regid is not provided
  if (!regid) {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card border-danger">
              <div className="card-body text-center p-4">
                <i className="fas fa-exclamation-triangle text-danger mb-3" style={{fontSize: '2rem'}}></i>
                <h4>Access Error</h4>
                <p className="text-muted">Registration ID not provided</p>
                <small className="text-info">
                  Current URL: {window.location.href}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (apiError) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card border-warning">
              <div className="card-body text-center p-4">
                <i className="fas fa-exclamation-circle text-warning mb-3" style={{fontSize: '2rem'}}></i>
                <h4>API Error</h4>
                <p className="text-muted">{apiError}</p>
                <small className="text-info">RegID: {regid}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!student) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card border-danger">
              <div className="card-body text-center p-4">
                <i className="fas fa-exclamation-triangle text-danger mb-3" style={{fontSize: '2rem'}}></i>
                <h4>Certificate Not Found</h4>
                <p className="text-muted">No student found for registration ID: {regid}</p>
                <small className="text-info">
                  API URL: http://localhost:8080/api/verification/{regid}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-light min-vh-100">
      {/* Compact Header */}
      <div className="bg-white shadow-sm py-3">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="d-flex align-items-center">
                <div className="bg-primary rounded-circle me-3 d-flex align-items-center justify-content-center" 
                     style={{width: '50px', height: '50px'}}>
                  <i className="fas fa-graduation-cap text-white"></i>
                </div>
                <div>
                  <h4 className="mb-0 text-primary fw-bold">Excerpt IT Training Services</h4>
                  <small className="text-muted">Certificate Verification Portal</small>
                </div>
              </div>
            </div>
            <div className="col-md-4 text-md-end">
              <span className="badge bg-success px-3 py-2">
                <i className="fas fa-check-circle me-1"></i>Verified
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Certificate Card */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow border-0 w-100">
              <div className="card-header bg-primary text-white py-3">
                <div className="row align-items-center">
                  <div className="col">
                    <h5 className="mb-0 fw-bold">
                      <i className="fas fa-certificate me-2"></i>Certificate Details
                    </h5>
                  </div>
                  <div className="col-auto">
                    <small>ID: {student.regid}</small>
                  </div>
                </div>
              </div>
              
              <div className="card-body p-4">
                <div className="row g-4">
                  {/* Student Info */}
                  <div className="col-md-6">
                    <h6 className="text-primary fw-semibold mb-3">
                      <i className="fas fa-user me-2"></i>Student Information
                    </h6>
                    <div className="mb-3">
                      <label className="fw-bold text-dark small">FULL NAME</label>
                      <p className="h5 mb-1">{capitalizeName(student.fName)} {capitalizeName(student.lName)}</p>
                    </div>
                    <div>
                      <label className="fw-bold text-dark small">FATHER'S NAME</label>
                      <p className="mb-0">{toCamelCase(student.guardianName)}</p>
                    </div>
                  </div>

                  {/* Course Info */}
                  <div className="col-md-6">
                    <h6 className="text-success fw-semibold mb-3">
                      <i className="fas fa-book me-2"></i>Course Information
                    </h6>
                    <div className="mb-3">
                      <label className="fw-bold text-dark small">COURSE NAME</label>
                      <p className="h6 mb-1">{toCamelCase(student.courseName)}</p>
                    </div>
                    <div>
                      <label className="fw-bold text-dark small">GRADE ACHIEVED</label>
                      <div className="mt-1">
                        <span className="badge bg-warning text-dark fs-6 px-3 py-2">
                          {student.certificateGrade}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Verification Footer */}
              <div className="card-footer bg-light py-3">
                <div className="row align-items-center">
                  <div className="col">
                    <div className="d-flex align-items-center">
                      <i className="fas fa-shield-check text-success me-2"></i>
                    </div>
                  </div>
                  <div className="col-auto">
                    <small className="text-muted">
                      © Excerpt IT Training Services
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetail;